import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Button, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { useGetDta } from '../../hooks/useGetDta';
import { useForm } from '../../hooks/useForm';
import { fetchConToken } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';

const MenuPerzonalizado = () => {
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const { loading, data } = useGetDta('main/portal/menu');
    const [values, handleInputChange, setFormValue] = useForm({
        id: '',
        mimenu: '',
    });
    useEffect(() => {
        setFormValue({ ...values, ...data });
    }, [data]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);

        let res = await fetchConToken(`main/portal`, { id: values.id, items: { ...values } }, 'POST');
        setResp(res);
        setLoad(false);
    };
    if (loading) return <LoadinSpin />;
    return (
        <div>
            <Card>
                <Card.Header>Menu personalizado</Card.Header>
                <Card.Body>
                    <Form noValidate onSubmit={onSubmit}>
                        <Col>
                            {' '}
                            <Form.Group className="mb-3" controlId="validationCusto">
                                <Form.Label> Información adicional</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    rows={21}
                                    as={'textarea'}
                                    value={values.mimenu}
                                    name="mimenu"
                                    onChange={handleInputChange}
                                />
                                <Form.Control.Feedback>Válido</Form.Control.Feedback>
                            </Form.Group>{' '}
                        </Col>

                        {load ? (
                            <Button color="primary" disabled>
                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                Guardando...
                            </Button>
                        ) : (
                            <Button type="submit">Guardar</Button>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default MenuPerzonalizado;
